exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pd-10[data-v-76af7e01] {\n  padding: 10px 0px;\n}\n.rotate-icon[data-v-76af7e01] {\n  transform: rotate(45deg);\n}\n.custom-file-round[data-v-76af7e01] {\n  background-color: #ffffff;\n  border: 1px solid #cad0d7;\n  border-radius: 8px;\n  letter-spacing: 0.02em;\n  color: rgba(6, 38, 62, 0.64);\n  font-weight: 500;\n  font-size: 13px;\n  height: 35px;\n}\n", ""]);

// exports
